<template lang="pug">
  app-modal(
    @closeModal="$emit('closeModal')"
    titulo="Cadastro desatualizado"
  )
    template(slot="body")
      el-row.margin-bottom
        b Atenção:
        span &nbsp Este .sicarf foi gerado em uma versão antiga do SiCARF-OFF (Módulo de cadastros)! Por favor, atualize para a versão mais recente, gere um novo .sicarf e tente enviar novamente!
      el-row.margin-bottom
        span Para atualizar, siga os seguintes passos:
      el-row.margin-left
        el-row.margin-bottom5
          span 1) No site, acesse a aba "Como Baixar" e baixe novamente o módulo de cadastros.
        el-row.margin-bottom5
          span 2) Execute o instalador para atualizar o sistema. Não se preocupe, você não perderá os cadastros já realizados!
        el-row.margin-bottom5
          span 3) Após atualizar o módulo de cadastros, você deverá finalizar novamente os cadastros e exportá-los.
        el-row.margin-bottom5
          span 4) Com o .sicarf gerado pela nova versão, você retornará na aba "Como enviar" do site para realizar o envio novamente.

    template(slot="footer")
      .flex
          el-button(type="primary", @click="$emit('closeModal')")
            span
              i.fa.fa-check
              span &nbsp Confirmar
</template>

<script>
import AppModal from '@/components/AppModal'

export default {

  components: {
    AppModal
  }
}

</script>

<style scoped lang="scss">

.flex {
  display: flex;
  justify-content: center;
  padding: 0 15px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-bottom5 {
  margin-bottom: 5px;
}

.margin-left {
  margin-left: 10px;
}

/deep/ .el-button span {
  display: flex;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppModalErroVersao.vue